import Loadable from "@cores/loadable";

const LoadableVideoDetail = Loadable({
    loader: () => import('./VideoDetail'),
    loading: () => null
});

export default LoadableVideoDetail;
